module.exports = __webpack_public_path__ + "static/media/age_rating_7.c303d8c9.svg";